import { DictionaryMapValueType } from '@components/dictionary/dictionaryIntializer';
import { ProfiBazaAPIModels } from 'services/src/profiBazaAPI';

export const mappings = new Map<
    ProfiBazaAPIModels.SubjectKind,
    DictionaryMapValueType
>([
    [ProfiBazaAPIModels.SubjectKind.PSSE, { displayName: 'PSSE', disable: false }],
    [ProfiBazaAPIModels.SubjectKind.WSSE, { displayName: 'WSSE', disable: false }],
    [ProfiBazaAPIModels.SubjectKind.GSSE, { displayName: 'GSSE', disable: false }],
    [ProfiBazaAPIModels.SubjectKind.PZH, { displayName: 'PZH', disable: false }],
    [ProfiBazaAPIModels.SubjectKind.EDUCATIONALUNIT, { displayName: 'Jednostka oświatowa', disable: false }],
    [ProfiBazaAPIModels.SubjectKind.GM, { displayName: 'Gmina Miejska', disable: false }],
    [ProfiBazaAPIModels.SubjectKind.GMW, { displayName: 'Gmina Miejsko-Wiejska', disable: false }],
    [ProfiBazaAPIModels.SubjectKind.GW, { displayName: 'Gmina Wiejska', disable: false }],
    [ProfiBazaAPIModels.SubjectKind.MNP, { displayName: 'Miasto na pr. powiatu', disable: false }],
    [ProfiBazaAPIModels.SubjectKind.SP, { displayName: 'Starostwo Powiatowe', disable: false }],
    [ProfiBazaAPIModels.SubjectKind.UW, { displayName: 'Urząd Wojewódzki', disable: false }],
    [ProfiBazaAPIModels.SubjectKind.UM, { displayName: 'Urząd Marszałkowski', disable: false }],
    [ProfiBazaAPIModels.SubjectKind.IC, { displayName: 'Instytucja centralna', disable: false }],
    [ProfiBazaAPIModels.SubjectKind.M, { displayName: 'Ministerstwo', disable: false }],
    [ProfiBazaAPIModels.SubjectKind.MED, { displayName: 'Podmiot leczniczy', disable: false }],
    [ProfiBazaAPIModels.SubjectKind.NGO, { displayName: 'NGO', disable: false }],
    [ProfiBazaAPIModels.SubjectKind.OTH, { displayName: 'Inne', disable: false }],
    [ProfiBazaAPIModels.SubjectKind.GIS, { displayName: 'GIS', disable: true }],
    [ProfiBazaAPIModels.SubjectKind.HOSPITAL, { displayName: 'Szpital', disable: true }],
    [ProfiBazaAPIModels.SubjectKind.CONTRACTOR, { displayName: 'Kontrahent', disable: true }],
    [ProfiBazaAPIModels.SubjectKind.WCZP, { displayName: 'WCZP', disable: true }],
    [ProfiBazaAPIModels.SubjectKind.DEPARTMENT, { displayName: 'Dział', disable: true }],
    [ProfiBazaAPIModels.SubjectKind.DISTRICT, { displayName: 'Urząd Dzielnicy', disable: true }],

]);

export const map = (
    value: ProfiBazaAPIModels.SubjectKind
): string => mappings.get(value)?.displayName ?? '';